import { LOADING_STATUS } from '../../../shared/constants/loadingStatus';

export function getShowTemplatesCardsSpinner({
  listStatus,
  itemsLength,
  isSearchActive,
  hasLoadedOnce,
}) {
  return (
    !isSearchActive &&
    itemsLength === 0 &&
    Boolean(hasLoadedOnce) &&
    (listStatus === LOADING_STATUS.LOADING || listStatus === LOADING_STATUS.IDLE)
  );
}
